import React, {Component} from 'react';
import {ajax, unparam} from "../../utils/common";
import Human from './human';
import Other from './other';

class Index extends Component {
  state = {
    isHuman: false,
    isValid: true,   // 报告是否有效
  }

  UNSAFE_componentWillMount() {
    //获取页面参数
    const queryString = unparam(location.search);
    // 国际化
    const lang = queryString.lang ? queryString.lang.toLocaleLowerCase() : "zh_cn";
    //页面适配，移动端打开跳转到移动端页面
    if (window.navigator.userAgent.indexOf("Mobile") >= 0) {
      this.props.history.replace({
        pathname: "/result/mobile",
        search: "?accountId=" + queryString.accountId + "&lang=" + lang + (queryString.hrInfo ? "&hrInfo=" + queryString.hrInfo : '')
      })
      return false;
    }
    ajax({
      url: "/rept/account/queryEmoProducer",
      data: {
        accountId: queryString.accountId,
        timestamp: queryString.timestamp,
        sign: queryString.sign,
      }
    }).then(res => {
      this.setState({
        isHuman: res.data.emoProducer === 'human'
      });
    }).catch(err => {
      console.log("result fail: ", err)
      // 处理无权限
      if(err.response.status === 403){
          this.setState({
            isValid: false
          })
      }
    })
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isHuman ? <Human /> : <Other isValid={this.state.isValid} />}
      </React.Fragment>
    );
  }
}

export default Index;
